/**
 * Supplier MOQ Checker
 * Groups cart quantities by supplier and checks supplier MOQ.
 * Supplier names are never shown to customers.
 */

class SupplierMOQChecker {
  constructor() {
    const dataBlocks = document.querySelectorAll('script.supplier-moq-data');
    if (!dataBlocks.length) return;

    const i18nBlock = document.querySelector('script.supplier-moq-i18n');
    this.i18n = i18nBlock ? JSON.parse(i18nBlock.textContent) : {
      label: 'Minimum order',
      inCart: 'In cart',
      needed: 'Still needed'
    };

    const itemMap = new Map();
    dataBlocks.forEach((block) => {
      try {
        const data = JSON.parse(block.textContent);
        data.items.forEach((item) => {
          itemMap.set(item.variantId, item);
        });
      } catch (error) {
        console.warn('[MOQ] Data error:', error);
      }
    });

    this.items = Array.from(itemMap.values());
    this.checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], .cart__checkout-button'
    );
    this.errorContainers = this.getErrorContainers();
    this.validate();
  }

  getErrorContainers() {
    const containers = [];
    const locations = [
      document.querySelector('#main-cart-footer .js-contents'),
      document.querySelector('.cart-drawer__footer')
    ];
    locations.forEach((location) => {
      if (!location) return;
      let box = location.querySelector('.supplier-moq-errors');
      if (!box) {
        box = document.createElement('div');
        box.className = 'supplier-moq-errors';
        box.style.cssText = 'display:none;margin-bottom:16px;';
        location.insertBefore(box, location.firstChild);
      }
      containers.push(box);
    });
    return containers;
  }

  validate() {
    const suppliers = {};

    this.items.forEach((item) => {
      if (!item.supplierGid) return;
      if (!item.moq || item.moq <= 0) return;

      if (!suppliers[item.supplierGid]) {
        suppliers[item.supplierGid] = {
          moq: Number(item.moq),
          unit: item.moqUnit || 'm²',
          quantity: 0,
          productTitles: []
        };
      }

      suppliers[item.supplierGid].quantity += Number(item.quantity);

      if (item.productTitle && !suppliers[item.supplierGid].productTitles.includes(item.productTitle)) {
        suppliers[item.supplierGid].productTitles.push(item.productTitle);
      }
    });

    const errors = [];

    Object.values(suppliers).forEach((supplier) => {
      if (supplier.quantity < supplier.moq) {
        const needed = supplier.moq - supplier.quantity;
        errors.push({
          products: supplier.productTitles.join(', '),
          moq: supplier.moq,
          unit: supplier.unit,
          inCart: supplier.quantity,
          needed: needed
        });
      }
    });

    this.render(errors);
    this.toggleCheckout(errors.length === 0);
  }

  render(errors) {
    this.errorContainers.forEach((container) => {
      if (errors.length) {
        container.innerHTML = errors.map((e) => `
          <div class="moq-warning-card">
            <div class="moq-warning-products">${e.products}</div>
            <div class="moq-warning-separator">—</div>
            <div class="moq-warning-details">
              <span>${this.i18n.label}: ${e.moq}${e.unit}</span>
              <span aria-hidden="true">·</span>
              <span>${this.i18n.inCart}: ${e.inCart}${e.unit}</span>
              <span aria-hidden="true">·</span>
              <span>${this.i18n.needed}: ${e.needed}${e.unit}</span>
            </div>
          </div>
        `).join('');
        container.style.display = 'block';
      } else {
        container.innerHTML = '';
        container.style.display = 'none';
      }
    });
  }

  toggleCheckout(enabled) {
  this.checkoutButtons.forEach((button) => {
    button.disabled = !enabled;
    button.style.opacity = enabled ? '' : '0.4';
    button.style.pointerEvents = enabled ? '' : 'none';
  });
}
}

function initSupplierMOQ() {
  new SupplierMOQChecker();
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', initSupplierMOQ);

// Watch for Dawn's cart AJAX re-renders
// Dawn replaces innerHTML of these containers after quantity changes
function observeCartUpdates() {
  const targets = [
    document.querySelector('#main-cart-items'),
    document.querySelector('#main-cart-footer')
  ].filter(Boolean);

  if (!targets.length) return;

  let debounceTimer;

  const observer = new MutationObserver(() => {
    // Debounce to avoid firing multiple times per render
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      initSupplierMOQ();
    }, 400);
  });

  targets.forEach((target) => {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });
}

document.addEventListener('DOMContentLoaded', observeCartUpdates);
// Intercept cart form submit — redirect to /checkout directly
// instead of POSTing to /cart (which just refreshes the page)
document.addEventListener('submit', (e) => {
  const form = e.target;
  if (form.id !== 'cart') return;
  if (document.activeElement && document.activeElement.name === 'checkout') {
    e.preventDefault();
    window.location.href = '/checkout';
  }
}, true);
